import { useUrlState } from "@/app/navigation";
import { useDialogReset } from "@/components/workspace/use-dialog-reset";

export function useConnectionReset(open: boolean, hasConnection: boolean, reset: () => void) {
  const { params } = useUrlState();
  useDialogReset(open && (!hasConnection || params.get("integrationEdit") === "1"), reset);
}
